// Water Rights
export const WATER_RIGHTS = '/water_right';
export const GET_WATER_RIGHTS = '/water_right/';
export const GET_WATER_RIGHTS_QUERY = '/water_right/query';
export const DELETE_WATER_RIGHTS = '/water_right';
export const ADD_WATER_RIGHTS = '/water_right/';
export const UPDATE_WATER_RIGHTS = '/water_right';

// Water Rights Status
export const WATER_RIGHTS_STATUS = '/water_right/status';
export const GET_WATER_RIGHTS_STATUS = '/water_right/status/';
export const DELETE_WATER_RIGHTS_STATUS = '/water_right/status';
export const ADD_WATER_RIGHTS_STATUS = '/water_right/status/';
export const UPDATE_WATER_RIGHTS_STATUS = '/water_right/status';

// Water Rights Type
export const WATER_RIGHTS_TYPE = '/water_right/type';
export const GET_WATER_RIGHTS_TYPE = '/water_right/type/';
export const DELETE_WATER_RIGHTS_TYPE = '/water_right/type';
export const ADD_WATER_RIGHTS_TYPE = '/water_right/type/';
export const UPDATE_WATER_RIGHTS_TYPE = '/water_right/type';

// Water Rights Use
export const WATER_RIGHTS_USE = '/water_right/use';
export const GET_WATER_RIGHTS_USE = '/water_right/use/';
export const DELETE_WATER_RIGHTS_USE = '/water_right/use';
export const ADD_WATER_RIGHTS_USE = '/water_right/use/';
export const UPDATE_WATER_RIGHTS_USE = '/water_right/use';

// Water Rights Use Status
export const WATER_RIGHTS_USE_STATUS = '/water_right/use/status';
export const GET_WATER_RIGHTS_USE_STATUS = '/water_right/use/status/';
export const DELETE_WATER_RIGHTS_USE_STATUS = '/water_right/use/status';
export const ADD_WATER_RIGHTS_USE_STATUS = '/water_right/use/status/';
export const UPDATE_WATER_RIGHTS_USE_STATUS = '/water_right/use/status';

// Water Rights Classification
export const WATER_RIGHTS_CLASSIFICATION = '/water_right/classification';
export const GET_WATER_RIGHTS_CLASSIFICATION = '/water_right/classification/';
export const DELETE_WATER_RIGHTS_CLASSIFICATION = '/water_right/classification';
export const ADD_WATER_RIGHTS_CLASSIFICATION = '/water_right/classification/';
export const UPDATE_WATER_RIGHTS_CLASSIFICATION = '/water_right/classification';

// Water Rights Distribution
export const WATER_RIGHTS_DISTRIBUTION = '/water_right/distribution';
export const GET_WATER_RIGHTS_DISTRIBUTION = '/water_right/distribution/';
export const DELETE_WATER_RIGHTS_DISTRIBUTION = '/water_right/distribution';
export const ADD_WATER_RIGHTS_DISTRIBUTION = '/water_right/distribution/';
export const UPDATE_WATER_RIGHTS_DISTRIBUTION = '/water_right/distribution';

// Water Rights Source
export const WATER_RIGHTS_SOURCE = '/water_right/source';
export const GET_WATER_RIGHTS_SOURCE = '/water_right/source/';
export const DELETE_WATER_RIGHTS_SOURCE = '/water_right/source';
export const ADD_WATER_RIGHTS_SOURCE = '/water_right/source/';
export const UPDATE_WATER_RIGHTS_SOURCE = '/water_right/source';

// Water Rights Unit
export const WATER_RIGHTS_UNIT = '/water_right/unit';
export const GET_WATER_RIGHTS_UNIT = '/water_right/unit/';
export const DELETE_WATER_RIGHTS_UNIT = '/water_right/unit';
export const ADD_WATER_RIGHTS_UNIT = '/water_right/unit/';
export const UPDATE_WATER_RIGHTS_UNIT = '/water_right/unit';

// Dashboard
export const DASHBOARD_TOTALS = '/dashboard/totals';
export const DASHBOARD_BY_ESTABLISHMENT_TYPE = '/dashboard/water_rights_by_establishment_type';
export const DASHBOARD_RIGHT_EXERCISE = '/dashboard/right_exercise_by_establishment_type';
export const DASHBOARD_WATER_RIGHT_TYPE = '/dashboard/water_right_type_by_establishment_type';
export const DASHBOARD_MAP = '/dashboard/map';
export const DASHBOARD_MAP_COORDINATES = '/dashboard/map/coordinates';
export const DASHBOARD_WORK_ORDER_REPORTING = '/dashboard/work_order_reporting_by_establishment_type';
export const DASHBOARD_WORK_ORDER_STATUS = '/dashboard/work_order_status_by_establishment_type';
